import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { Connect, PropsFromRedux } from './ExcludeContainer';
import { CommonSection } from '../CommonSection';
import { searchConstants } from '../../../search-utils/searchConstants';
import { Checkbox } from '../../../../components/checkbox/Checkbox';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { UserContextType } from '../../../../user/user.types';
import { withUser } from '../../../../user/UserContext';

type Props = PropsFromRedux & UserContextType & WithRestrictedModalProps;

export class RawExclude extends React.Component<Props> {
  excludePart = () => {
    const {
      accessPremium,
      toggleCheckbox,
      openRestrictedModal,
      excludeMoyensAnnexes,
    } = this.props;
    if (!accessPremium) {
      openRestrictedModal('faceted-item');
    } else {
      doctrineAnalytics('Search ExcludeMeansClicked', {
        type: excludeMoyensAnnexes ? 'deselect' : 'select',
      });
      toggleCheckbox();
    }
  };

  render() {
    const { excludeMoyensAnnexes } = this.props;
    return (
      <CommonSection title={searchConstants.filters.exclude}>
        <button
          data-test-id="exclude"
          type="button"
          onClick={this.excludePart}
          className="search-filters-checkbox"
          title="Exclure les moyens annexés (Cour de cassation)"
        >
          <div className="search-filters-checkbox__wrapper">
            <span className="search-filters-checkbox__icon">
              <Checkbox checked={excludeMoyensAnnexes} />
            </span>
            <span className="search-filters-checkbox__label">
              <FormattedMessage id="search/components/aside-filters/exclude/Exclude.tsx/1" />
            </span>
          </div>
        </button>
      </CommonSection>
    );
  }
}

export const Exclude = withUser(withRestrictedModal(Connect(RawExclude)));
